export default __webpack_public_path__ + "static/media/95t.5d38ff33.jpg";